import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getContentList } from '../utils/getContent';

export default function Institucional() {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState(null);

  useEffect(() => {
    getContentList('q-mob-institucional', i18n.language.split('-')[0]).then((data) => {
      setContent(data);
    });
  }, [i18n.language.split('-')[0]]);

  return (
    <div className="container p-lg-5">
      {content && (<h3 className="display-5 mb-3">{content.data.Titulo}</h3>)}
      <p>
        {content && (<span
          dangerouslySetInnerHTML={{
            __html: content.data.Texto
          }}
        ></span>)}
      </p>
    </div>
  );
}
/*
import { h } from "preact";
import Parser from "html-react-parser";
import { useTranslation } from "react-i18next";
import React from 'react';

import {
  LANGUAGE_EN_CODE,
  LANGUAGE_ES_CODE,
  LANGUAGE_PT_CODE,
} from "../utils/constants";
import useContentfulContent from "../hooks/useContentfulContent";
import ContentPage from "../components/ContentPage";

const PAGE_ID_BY_LANG = {
  [LANGUAGE_PT_CODE]: "4ZYc0FyhFAHkdNUzesWkjU",
  [LANGUAGE_EN_CODE]: "5oj7AbHoyWH0fnbN0rpmEw",
  [LANGUAGE_ES_CODE]: "19PWBfIzoH7ZPFYyM9O4Id",
};

export default function Institucional() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage;
  const pageId = PAGE_ID_BY_LANG[currentLang];

  const { title, content } = useContentfulContent(pageId);

  return (
    <ContentPage title={title} content={Parser(content)} />
  );
}*/